<script setup lang="ts">
const { form } = defineProps<{
  form: Form & { formQuestions: FormQuestion[] }
  // TODO: submission not in use ATM
  // submission: FormSubmission
}>()

const { t } = useI18n({ useScope: 'local' })

const successMessageConfig = form.successMessageConfig
const { title, body, button, thankYouGif } = successMessageConfig || {}

</script>

<template>
  <FormCard
    :title="title"
    :sub-title="t('subTitle')"
    :is-submitting="false"
    icon="ph:check-circle-fill"
  >
    <div class="col-span-full flex flex-col gap-4">
      <MarkdownRenderer v-if="body" :content="body" />
      <BaseParagraph v-else>
        {{ t('description') }}
      </BaseParagraph>

      <img
        v-if="thankYouGif"
        src="/img/gifs/thank-you.gif"
        alt="Iemand die 'Thank you' zegt"
        class="w-full rounded-lg"
      >

      <BaseButton v-if="button" :to="button.to">
        {{ button.text }}
      </BaseButton>
    </div>

    <!-- Hide the buttons -->
    <template #buttons>
      <div />
    </template>
  </FormCard>
</template>

<i18n lang="json">
{
  "en": {
    "subTitle": "Thank you for submitting",
    "description": "Thank you for submitting this form. 🙏 You can now close this page."
  },
  "nl": {
    "subTitle": "Bedankt voor het invullen",
    "description": "Bedankt voor het invullen van dit formulier. 🙏 Je kunt dit scherm nu sluiten."
  }
}
</i18n>
